'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
class Slider {
    constructor() {
        const swiper = new swiper_1.default('.bulletSwiper', {
            modules: [modules_1.Autoplay],
            loop: true,
            speed: 15000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
            },
            slidesPerView: "auto",
            spaceBetween: 15,
            breakpoints: {
                // スライドの表示枚数：768px以上の場合
                768: {
                    spaceBetween: 40,
                }
            }
        });
    }
}
exports.Slider = Slider;
exports.default = Slider;
